// postingTypesService.js

import { AccountsAPI } from "api/axios.config";
import CONSTANT from "CONSTANT/Matter/PostingTypes";

function resolveGroup(type) {
  switch (type) {
    case CONSTANT.OP:
      return "office";
    case CONSTANT.CP:
      return "client";
    case CONSTANT.BP:
      return "all";
    case CONSTANT.BNKP:
      return "bank";
    case CONSTANT.PI:
      return "purchase";
    case CONSTANT.DIS:
      return "disbursement";
    case CONSTANT.TRANS:
      return "transfers";
    case "chits":
      return "chits";
    default:
      return "all";
  }
}

export const getSupplierPostings = (
  supplierRef,
  IncludeReversals,
  FromDate,
  ToDate,
  type,
) => {
  let url = `/Postings/Supplier/${supplierRef}`;
  const queryParams = new URLSearchParams();

  if (type) {
    queryParams.append("type", type);
  }

  if (IncludeReversals) {
    queryParams.append("IncludeReversals", IncludeReversals);
  }

  if (FromDate) {
    queryParams.append("FromDate", FromDate);
  }
  if (ToDate) {
    queryParams.append("ToDate", ToDate);
  }

  const qs = queryParams.toString();
  if (qs) {
    url += `?${qs}`;
  }
  return AccountsAPI.get(url);
};

export const getNominalRef = (
  nominalRef,
  IncludeReversals,
  FromDate,
  ToDate,
) => {
  let url = `/Postings/Nominal/${nominalRef}`;
  const queryParams = new URLSearchParams();

  if (IncludeReversals) {
    queryParams.append("IncludeReversals", IncludeReversals);
  }
  if (FromDate) {
    queryParams.append("FromDate", FromDate);
  }
  if (ToDate) {
    queryParams.append("ToDate", ToDate);
  }

  const qs = queryParams.toString();
  if (qs) {
    url += `?${qs}`;
  }
  return AccountsAPI.get(url);
};

const buildPostingTypesUrl = (type, options = {}) => {
  const group = resolveGroup(type);

  const fields = [
    "name",
    "code",
    "display",
    ...(type === "chits" || type === "all" ? ["displayFields"] : []),
  ];

  const params = new URLSearchParams({
    group,
    fields: fields.join(","),
  });

  if (options.unallocated === true) {
    params.append("Unallocated", "true");
  }

  return `/postingtypes?${params.toString()}`;
};

const postingTypesCache = {};
const postingTypesInFlight = {};

export const getCachedPostingTypes = (type, options = {}) =>
  postingTypesCache[buildPostingTypesUrl(type, options)];

const getPostingTypes = async (type, options = {}) => {
  const url = buildPostingTypesUrl(type, options);

  if (postingTypesCache[url]) return postingTypesCache[url];

  if (!postingTypesInFlight[url]) {
    postingTypesInFlight[url] = AccountsAPI.get(url)
      .then((res) => {
        const data = res?.data?.data || [];
        if (data.length) postingTypesCache[url] = data;
        return data;
      })
      .finally(() => {
        delete postingTypesInFlight[url];
      });
  }

  return postingTypesInFlight[url];
};

const getPostingTypeDetails = async (type) => {
  const fields = ["name", "code", "display", "displayFields"];

  const url = `/postingtypes/${type}?${new URLSearchParams({
    fields: fields.join(","),
  }).toString()}`;

  const res = await AccountsAPI.get(url);
  return res?.data?.data || [];
};

export { getPostingTypes, getPostingTypeDetails };
